import { useTranslation } from "react-i18next";
import PageTemplate from "../components/PageTemplates.tsx";
import React from "react";

function CareerTraining() {
  const { t, i18n } = useTranslation();

  return (
    <PageTemplate
      title={t("careerTraining")}
      subtitle={t("careerList")}
      type="DESIGNER_CAREER_PLANNING"
    />
  );
}

export default CareerTraining;
